<template>
  <div class="speflly">
    <sec-title Text="法律领域" class="text_center" />
    <!-- <div class="mt10 genduo">更多>></div> -->
    <div class="cont between mt20">
      <div class="leftmenu">
        <div class="hea">- 法律领域分类-</div>
        <div class="menlist">
          <div
            class="menitem"
            v-for="(item, index) in ifylist"
            :key="index"
            @click="mencli(index)"
            :class="{ menactiv: activ == index }"
          >
            {{item.name}}
          </div>
        </div>
        <div class="sertel flex_start">
          <div><img src="../../../assets/special/fllytel.png" alt="" /></div>
          <div>
            <div class="tl1">服务咨询热线</div>
            <div class="tl2">400-0000-000</div>
          </div>
        </div>
      </div>
      <div class="rightcont between wrap">
        <div
          class="contitem"
          v-for="(item, index) in newlist"
          :key="index"
          @click="tojump(item)"
        >
          <div><img :src="item.preview_pic" /></div>
          <div class="text ellipsis">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
export default {
  components: {
    secTitle,
  },
  data() {
    return {
      activ: 0,
      ifylist: [],
      newlist: [],
    };
  },

  beforeMount() {
    this.getproblem();
  },
  methods: {
    mencli(index) {
      this.activ = index;
      this.getlawon();
    },

    tojump(current) {
      console.log(current);
      this.$router.push({
        path: "/laws/specialdet",
        query: {
          lawonId: current.id,
        },
      });
    },
    getproblem() {
      this.$http.fdlaw.getIndustryIfy().then((res) => {
        this.ifylist = res.data;
        this.getlawon();
      });
    },
    getlawon() {
      let data = {
        limit: 6,
        cat_id: this.ifylist[this.activ].id,
        order: "new",
        page: 1,
      };
      this.$http.laws.getnewslist(data).then((res) => {
        this.newlist = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.speflly {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .genduo {
    width: 100%;
    cursor: pointer;
    text-align: right;
    font-size: 16px;
    color: #333333;
  }
  .cont {
    align-items: flex-start;
    .leftmenu {
      width: 240px;
      background: #ffffff;
      box-shadow: 0px 5px 8px 0px rgba(112, 112, 112, 0.1);
      .hea {
        width: 100%;
        height: 112px;
        line-height: 112px;
        text-align: center;
        background: #0465ea;
        font-size: 24px;
        font-weight: bold;
        color: #ffffff;
      }
      .menlist {
        width: 100%;
        .menitem {
          cursor: pointer;
          width: 100%;
          height: 64px;
          line-height: 64px;
          border-bottom: 1px solid #eee;
          text-align: center;
          font-size: 18px;
          color: #666666;
          &.menactiv {
            color: #0465ea;
          }
        }
      }
      .sertel {
        padding: 28px 0 28px 26px;
        border-bottom: 1px solid #eee;
        img {
          width: 44px;
          height: 44px;
          margin-right: 12px;
        }
        .tl1 {
          font-size: 15px;
          color: #0465ea;
        }
        .tl2 {
          font-size: 21px;
          color: #0465ea;
        }
      }
    }
    .rightcont {
      width: 940px;
      .contitem {
        width: 300px;
        height: 280px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 2px rgba(4, 101, 234, 0.1);
        margin-bottom: 40px;
        .text {
          font-size: 18px;
          color: #333333;
          height: 50px;
          text-align: center;
          line-height: 50px;
        }
        img {
          width: 100%;
          height: 230px;
        }
      }
    }
  }
}
</style>